import isEmail from 'validator/lib/isEmail';

export default (message = 'Please enter a valid email address.') =>
  (value: string) => {
    if (!value) {
      return true;
    }
    return isEmail(value) || message;
  };
